import axios from "axios";
import listasPrecioService from "@/services/listasPrecioService";

const state = () => ({
  productos: [],
  productoEditar:null,
  catalogosBancos:[],
  bancos:[],
  tiposTarjetas:[],
  loderProducts: false,
  
  listasPrecio: [],
  listaSeleccionada: null,
});
const getters = {
  tiposTarjetasState(state) {
    return state.tiposTarjetas;
  },
  bancosState(state) {
    return state.bancos;
  },
  productosState(state) {
    return state.productos;
  },
  productosActivosState(state) {
    return state.productos.filter(p => p.activo === 1);
  },
  loderTableProductsState(state) {
    return state.loderProducts;
  },
  listasPrecioState(state) {
    return state.listasPrecio;
  },
  listaSeleccionadaState(state) {
    return state.listaSeleccionada;
  },
  getProductoSeleccionado(state){
    return state.productoEditar
  }
};
const mutations = {
  setProductoSeleccionado(state,prductoSeleccionado){
    state.productoEditar = prductoSeleccionado
  },
  getProductosLoad(state, payload) {
    state.productos = payload;
    state.loderProducts = false;
  },
  getCatalogosLoad(state, payload) {
    state.catalogosBancos = payload;
    state.bancos= payload.bancos
    state.tiposTarjetas= payload.mediosPago
  },
  setListasPrecio(state, payload) {
    state.listasPrecio = payload;
  },
  setListaSeleccionada(state, payload) {
    state.listaSeleccionada = payload;
  },
  setLoaderProducts(state, payload) {
    state.loderProducts = payload;
  },
  clearProductos(state) {
    state.productos = [];
  }
};
const actions = {
  seleccionarProducto({commit},payload){
    commit("setProductoSeleccionado",payload)

  },
  async getProductos({ commit, state, dispatch }, refresh) {
    try {
      // Asegurarse de que haya una lista de precios seleccionada
      if (!state.listaSeleccionada) {
        await dispatch('getListasPrecio');
      }

      // Solo recargar productos si no hay o si se solicita refresh
      if (state.productos.length === 0 || refresh) {
        commit("setLoaderProducts", true);
        commit("clearProductos"); // Limpiamos los productos antes de cargar nuevos
        
        const resp = await axios.get(
          `${process.env.VUE_APP_BASE_URL}productos?id_lista=${state.listaSeleccionada}`
        );
        commit("getProductosLoad", resp.data.data);
      }
    } catch (error) {
      console.error("Error al obtener productos:", error);
      commit("getProductosLoad", []);
      commit("setLoaderProducts", false);
    }
  },
  async getListasPrecio({ commit }) {
    try {
      const listas = await listasPrecioService.obtenerListasPrecio();

      commit("setListasPrecio", listas);

      // Establecer lista predeterminada si existe
      const listaPredeterminada = listas.find((lista) => lista.predeterminada);
      if (listaPredeterminada) {
        commit("setListaSeleccionada", listaPredeterminada.id_lista);
      }

      return listas;
    } catch (error) {
      console.error("Error al obtener listas de precios:", error);
      return [];
    }
  },
  async actualizarProductosPorLista({ commit }, params) {
    try {
      commit("setLoaderProducts", true);
      commit("clearProductos");
      commit("setListaSeleccionada", params.idLista);
      
      const url = params.venta 
      ? `${process.env.VUE_APP_BASE_URL}productos/combos?id_lista=${params.idLista}` 
      :`${process.env.VUE_APP_BASE_URL}productos?id_lista=${params.idLista}` ;
    
    const resp = await axios.get(url);
      if (resp.data && resp.data.data) {
        commit("getProductosLoad", resp.data.data);
      } else {
        console.error("Formato de respuesta inválido:", resp.data);
        commit("getProductosLoad", []);
      }
    } catch (error) {
      console.error("Error al actualizar productos por lista:", error);
      commit("getProductosLoad", []);
      commit("setLoaderProducts", false);
    }
  },
  getCatalogosBancos({ commit, state }, refresh) {
    return new Promise(async (resolve) => {
      try {
       
        if (state.catalogosBancos.length !== 0 && !refresh) {
          resolve();
          return;
        }
        state.catalogosBancos = [];
        
        let resp = await axios.get(process.env.VUE_APP_BASE_URL + "cajas/catalogos");
        commit("getCatalogosLoad", resp.data);
        resolve();
      } catch (e) {
        console.error("erroorrrr",e);
      }
    });
  }
};
export default {
  state,
  getters,
  actions,
  mutations,
};
